import { AfterViewInit, Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { Utils } from 'src/modules/utils/shared/utils';
import { ButtonDefinition } from '../../models/button-definition.model';
import { FrontendForm } from '../../netgen/FrontendForm';

@Component({
    selector: 'app-form-dialog',
    templateUrl: './form-dialog.component.html',
    styleUrls: [],
    standalone: false
})
export class FormDialogComponent implements AfterViewInit {

    app = inject(MainAppService);
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);

    @Input()
    form: FrontendForm = null;
    @Input()
    buttons: ButtonDefinition[] = [];

    @ViewChild('dialog') dialog: ElementRef;


    constructor() {
        this.form = this.config.data.form;
        this.buttons = this.config.data.buttons || [];
    }

    click(button: ButtonDefinition): void {
        if (button.isSuccess) {
            let errors = this.form.validate();
            if (!Utils.isNoe(errors)) {
                this.app.messageService.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: errors[0].message});
                return;
            }
        }

        this.ref.close(button.id);
    }

    keyPress(event: KeyboardEvent): void {
        if (event.key == "Enter") {
            this.click(this.buttons[0]);
        }
    }

    ngAfterViewInit(): void {
        if (this.form.submitOnEnter) {
            for (let field of this.form.fields) {
                field.onKeyPress = this.keyPress.bind(this);
            }
        }
        
        //Der doppelte AngularTimer (noch innerhalb focus) ist notwendig, sonst klappt es nicht
        GuiUtils.angularTimer(() =>  {
            this.form.fields[1]?.focus();
        });
    }

}